module.exports = __webpack_public_path__ + "static/media/ParagraphBlue.5624c4e0.svg";